'use strict';

angular.module('TurneroApp').component('coRecepcionDniSacar', {
    controller: [
        'turnosService', '$rootScope', 'utilsService', '$scope',
        function (turnosService, $rootScope, utilsService, $scope) {
            var ctrl = this;
            ctrl.Titulo = "Sacar un turno"

            ctrl.$onChanges = function () {
                ctrl.CUIL_DNI = '';
                ctrl.Persona = null;
                ctrl.PersonaLista = null;
                ctrl.Id_Sexo = null;

            };

            $scope.$on('limpiarRecepcion', function (event, bool) {
                ctrl.CUIL_DNI = '';
                ctrl.Persona = null;
                ctrl.PersonaLista = null;
                ctrl.Id_Sexo = null;
            });

            ctrl.buscarPersona = function () {
                ctrl.Persona = null;
                ctrl.PersonaLista = null;
                var Tipo_Doc = (ctrl.CUIL_DNI.toString().length < 9 ? 'DNI':'CUIL');
                var filtro = {
                    Id_Tipo_Doc: Tipo_Doc,
                    Nro_Documento: ctrl.CUIL_DNI,
                    Id_Sexo: ctrl.Id_Sexo
                }
                utilsService.swalTitle('Buscando ciudadano', 'info');
                turnosService.Get_Persona(filtro).$promise.then(function (resultado) {

                    if (resultado.Data.length == 1) {
                        ctrl.Persona = resultado.Data[0];
                        $rootScope.$broadcast('CiudadanoSeleccionado', ctrl.Persona);
                        ctrl.seleccionarPersona(ctrl.Persona)
                    } else if (resultado.Data.length > 1) {
                        ctrl.PersonasLista = resultado.Data
                    } else {
                        $rootScope.$broadcast('CiudadanoSeleccionado', null);
                    }
                    swal.close();

                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.seleccionarPersona = function (persona) {
                ctrl.personaSeleccionada = persona;
                ctrl.PersonasLista = null
                ctrl.CUIL_DNI = null;
                $rootScope.$broadcast('CiudadanoSeleccionado', ctrl.personaSeleccionada);

            };

            ctrl.setValor = function (value) {
                $rootScope.$broadcast('resetTimer', true);
                if (ctrl.CUIL_DNI != null && ctrl.CUIL_DNI.toString().length < 12) {
                    ctrl.CUIL_DNI = Number(ctrl.CUIL_DNI ? ctrl.CUIL_DNI.toString() + value.toString() : value.toString());
                } else if (ctrl.CUIL_DNI == null){
                    ctrl.CUIL_DNI = Number(value.toString());
                }
            }

            ctrl.backspace = function () {
                $rootScope.$broadcast('resetTimer', true);
                if (ctrl.CUIL_DNI  != null && ctrl.CUIL_DNI.toString().length > 0) {
                    ctrl.CUIL_DNI = Number(ctrl.CUIL_DNI.toString().slice(0, -1));
                    if (ctrl.CUIL_DNI == 0) {
                        ctrl.CUIL_DNI = null;
                        ctrl.Id_Sexo = null;
                    }
                }
            }

            ctrl.goHome = function () {
                ctrl.CUIL_DNI = null;
                ctrl.Id_Sexo = null;
                $rootScope.$broadcast('GoHome', true);
            }
        }
    ],
    template: require('./recepcion_DNI.html')
});



// WEBPACK FOOTER //
// ./app/components/recepcion/recepcion_DNISacarComponent.js